export const colors = {
  primary: "#7C83FD",
  secondary: "#96BAFF",
  secondaryLight: "#96baffd1",
  extra1: "#7DEDFF",
  extra2: "#88FFF7",
  extra3: "#efefef",
  extra3Light: "#efefefed"
};

export const shadows = {
  common: "0 4px 4px 0 #00000040",
};

export const fonts = {
  catamaran: "'Catamaran', sans-serif",
  handlee: "'Handlee', cursive",
};
